var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ThemePalette } from "../../../theme/_Types";
import { asThemeConsumer } from "../../../theme/Theme";
import { Button } from "../05-atoms/Button";
var ToggleMenuItemsComp = /** @class */ (function (_super) {
    __extends(ToggleMenuItemsComp, _super);
    function ToggleMenuItemsComp(props) {
        var _this = _super.call(this, props) || this;
        _this.onToggle = function () {
            _this.setState({
                show: !_this.state.show,
            });
        };
        _this.state = {
            show: false,
        };
        _this.onToggle = _this.onToggle.bind(_this);
        return _this;
    }
    /**
     *
     */
    ToggleMenuItemsComp.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            this.props.trigger,
            React.createElement(Button, { icon: "chevron-down", theme: { palette: ThemePalette.CONTRAST_ACCENT }, link: { onClick: function () { return _this.onToggle(); } }, className: "scl-o-togglemenuitems__trigger ".concat(this.state.show
                    ? "scl-o-togglemenuitems__trigger--open" : "scl-o-togglemenuitems__trigger--closed") }),
            React.createElement("div", { className: (this.state.show ? "scl-o-togglemenuitems--open"
                    : "scl-o-togglemenuitems--closed") }, this.props.content)));
    };
    return ToggleMenuItemsComp;
}(React.Component));
export { ToggleMenuItemsComp };
/**
 *
 */
export var ToggleMenuItems = asThemeConsumer(ToggleMenuItemsComp);
